var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5082_205565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.08 107.077C29.28 103.016 12 83.4271 12 59.7773C12 33.4998 33.6 12 60 12C86.4 12 108 33.4998 108 59.7773C108 83.4271 90.72 103.016 67.92 107.077L65.28 104.927H54.72L52.08 107.077Z",
    fill: "url(#paint0_linear_5082_205565)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.397 73.3248L80.5222 59.8398H68.007V50.4485C68.007 46.5957 69.4238 43.7061 75.0911 43.7061H81.2306V31.4251C77.9247 30.9435 74.1465 30.4619 70.8406 30.4619C59.9784 30.4619 52.422 37.2044 52.422 49.2445V59.8398H40.6152V73.3248H52.422V107.278C55.0195 107.76 57.617 108 60.2145 108C62.812 108 65.4095 107.76 68.007 107.278V73.3248H78.397Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5082_205565",
    x1: 60.0024,
    y1: 104.232,
    x2: 60.0024,
    y2: 11.9824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5082_205565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.97473837bd8ce88fdff63a065ac723cc.svg";
export { ForwardRef as ReactComponent };